<div class="translated-files">
  <div class="translated-files__empty" role="status">
    <p class="translated-files__empty-text">Translated files will appear here once available.</p>
  </div>
</div>
